/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDelegationSortCriteria {
    getFixupPrototypeFunction() { return UserDelegationSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<UserDelegationSortCriteria>): UserDelegationSortCriteria {
        let obj = Object.assign(new UserDelegationSortCriteria(), model);
        UserDelegationSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDelegationSortCriteria>): UserDelegationSortCriteria {
        if (!model) return null;
        return UserDelegationSortCriteria.newInstance(<UserDelegationSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDelegationSortCriteria) {
        if (!obj) return;

        models.UserDelegationSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDelegationSortCriteria): boolean {
        Object.setPrototypeOf(obj, UserDelegationSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.UserDelegationSortColumn;

    ascending: boolean;

}
